export default __webpack_public_path__ + "static/media/authentication1.139e633f.png";